export const DEFAULT_FEE_HEADS = [
  "Admission Fee", "Tuition Fee", "Annual Fee", "Examination Fee", "Computer Fee",
  "Activity Fee", "Development Fee", "Miscellaneous Fee", "Other Fee", "Old Fees",
];

export const DEFAULT_DISCOUNT_HEADS = [
  { name: "Sibling Discount", percent: 0, fixed: 0 },
  { name: "Staff Ward Discount", percent: 0, fixed: 0 },
  { name: "Merit Scholarship", percent: 0, fixed: 0 },
  { name: "Concession", percent: 0, fixed: 0 },
  { name: "Early Payment Discount", percent: 0, fixed: 0 },
];

export const DEFAULT_RECEIPT_FIELDS = [
  {
    "key": "logo",
    "label": "School Logo",
    "enabled": true,
    "x": 56,
    "y": 24,
    "font_size": 20
  },
  {
    "key": "school_name",
    "label": "School Name",
    "enabled": true,
    "x": 167,
    "y": 18,
    "font_size": 28,
    "font_face": "Times"
  },
  {
    "key": "address",
    "label": "School Address",
    "enabled": true,
    "x": 180,
    "y": 53,
    "font_size": 14
  },
  {
    "key": "contact",
    "label": "Phone / Email",
    "enabled": true,
    "x": 162,
    "y": 73,
    "font_size": 14
  },
  {
    "key": "receipt_no",
    "label": "Receipt No.",
    "enabled": true,
    "x": 278,
    "y": 102,
    "font_size": 11
  },
  {
    "key": "date",
    "label": "Date",
    "enabled": true,
    "x": 450,
    "y": 126,
    "font_size": 11
  },
  {
    "key": "student_name",
    "label": "Student Name",
    "enabled": true,
    "x": 37,
    "y": 102,
    "font_size": 11
  },
  {
    "key": "father_name",
    "label": "Father's Name",
    "enabled": true,
    "x": 41,
    "y": 126,
    "font_size": 11
  },
  {
    "key": "class",
    "label": "Class & Section",
    "enabled": true,
    "x": 278,
    "y": 126,
    "font_size": 11
  },
  {
    "key": "custom_1790354401116",
    "label": "Session",
    "enabled": true,
    "x": 450,
    "y": 102,
    "font_size": 11,
    "value": "2026-27"
  },
  {
    "key": "fee_breakdown",
    "label": "Fee Head Breakdown",
    "enabled": true,
    "x": 40,
    "y": 157,
    "font_size": 11,
    "width": 509,
    "height": 84
  },
  {
    "key": "amount_paid",
    "label": " Amount Paid                                                                                                                        ",
    "enabled": true,
    "x": 37,
    "y": 308,
    "font_size": 11,
    "width": 521,
    "height": 17,
    "heading": true
  },
  {
    "key": "due",
    "label": "  Balance Due                                                                                                                      ",
    "enabled": true,
    "x": 39,
    "y": 327,
    "font_size": 11,
    "width": 517,
    "height": 16,
    "heading": true
  },
  {
    "key": "payment_mode",
    "label": "Payment Mode",
    "enabled": true,
    "x": 39,
    "y": 350
  },
  {
    "key": "received_by",
    "label": "Received By",
    "enabled": true,
    "x": 429,
    "y": 350
  },
  {
    "key": "footer",
    "label": "Receipt Footer Note",
    "enabled": true,
    "x": 37,
    "y": 370,
    "width": 183,
    "height": 16
  },
  {
    "key": "line_1790417714622",
    "type": "line",
    "enabled": true,
    "x": 24,
    "y": 92,
    "width": 538,
    "color": "#333333"
  },
  {
    "key": "line_1790417837361",
    "type": "line",
    "enabled": true,
    "x": 24,
    "y": 146,
    "width": 534,
    "color": "#333333"
  }
];

export const DEFAULT_FEE_SECTION_ORDER = [
  "fee_heads", "discount_heads", "receipt_design", "receipt_due", "reminder", "payment",
];
